import { render, staticRenderFns } from "./o-searchresult.vue?vue&type=template&id=87336496&"
import script from "./o-searchresult.vue?vue&type=script&lang=js&"
export * from "./o-searchresult.vue?vue&type=script&lang=js&"
import style0 from "./o-searchresult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports